import { dispatcher, ingenuity, SpineBase, Container, clone, IEvent } from "@quest/base-core";
import { StickyFramesView } from "./StickyFramesView";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "../Platform/GameParserModel";
import { SlotConstants } from "@quest/slot-core";
import { SlotConstantsBehavior } from "@quest/murka-games-behavior-panther";
import { gameConstants } from "../Constants/gameConstants";
import { Linear } from "@quest/pixi-bridge";

export class StickyFramesContorller {
  protected view: StickyFramesView;
  private stickyFramesContainer: Container;
  private stickyFramesContainerFG: Container;
  private stickyData: any;
  private stickySymbolContainer: Container;
  private stickySymbolContainerFG: Container;

  constructor(view: StickyFramesView) {
    this.view = view;
    this.subscribeEvents();
    this.initializedElement();
  }

  private initializedElement(): void {
    this.stickySymbolContainer = this.view.getContainerByID('stickySymbolContainer');
    this.stickySymbolContainerFG = this.view.getContainerByID('stickySymbolContainerFG')
    this.stickyFramesContainer = this.view.getContainerByID("stickyFramesContainer");
    this.stickyFramesContainerFG = this.view.getContainerByID("stickyFramesContainerFG");
  }

  private subscribeEvents(): void {
    this.unubscribeEvents();
    dispatcher.on(eventDispatchers.ADD_STICKY_FRMAES, this.addStickyWildSymbol, this)
    dispatcher.on(eventDispatchers.ADD_STICKY_FRMAES_FG, this.addStickyWildSymbol, this);
    dispatcher.on(eventDispatchers.SHOW_OVERLAY, this.showOverlay, this)
    dispatcher.on(eventDispatchers.HIDE_OVERLAY, this.hideOverlay, this);
    dispatcher.on(eventDispatchers.GLOW_ALL_FRAMES, this.glowAllFrames, this)
    dispatcher.on(eventDispatchers.HIDE_STICKY_FRAMES_CONTAINER_FG, this.hideStickyWildContainer, this);
    dispatcher.on(eventDispatchers.HIDE_STICKY_FRAMES_CONTAINER, this.hideStickyWildContainer, this);
  }
  private unubscribeEvents(): void {
    dispatcher.off(eventDispatchers.ADD_STICKY_FRMAES_FG, this.addStickyWildSymbol, this);
    dispatcher.off(eventDispatchers.HIDE_STICKY_FRAMES_CONTAINER_FG, this.hideStickyWildContainer, this);
  }

  private showOverlay(): void {
    let overlay: Container;
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      overlay = this.view.getContainerByID('overlayContainer');
    } else {
      overlay = this.view.getContainerByID('overlayContainerFG');

    }
    overlay.alpha = 0;
    overlay.visible = true;
    let tweenOverlay = ingenuity.currentGame.add.tween(overlay).to({ alpha: 1 }, gameConstants.TIMER_100, Linear.None, true, 100, 0, false);
    tweenOverlay.onComplete.addOnce(() => {
      tweenOverlay.stop();
      ingenuity.currentGame.tweens.remove(tweenOverlay);
    })
  }

  private hideOverlay() {
    let overlay: Container;
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      overlay = this.view.getContainerByID('overlayContainer');
    } else {
      overlay = this.view.getContainerByID('overlayContainerFG');

    }
    let tween = ingenuity.currentGame.add.tween(overlay).to({ alpha: 0 }, SlotConstantsBehavior.DURATION_1200, Linear.None, true, 100, 0, false);
    tween.onComplete.addOnce(() => {
      overlay.visible = false;
      tween.stop();
      ingenuity.currentGame.tweens.remove(tween);
    })
  }

  private hideStickyWildContainer(): void {
    this.stickySymbolContainer.visible = false;
    this.stickyFramesContainer.alpha = 0;
    this.stickyFramesContainer.visible = false;
    this.stickyFramesContainer.removeChildren();
    this.stickySymbolContainerFG.visible = false;
    this.stickyFramesContainerFG.alpha = 0;
    this.stickyFramesContainerFG.visible = false;
    this.stickyFramesContainerFG.removeChildren();
    this.stickyData = [];
    this.resetStickyFramesData();
  }

  private resetStickyFramesData(): void {
    let rawFrameData: number[] = [];
    (ingenuity.parserModel as GameParserModel).setStikcyFramesOffsets(null);
    (ingenuity.parserModel as GameParserModel).setStikcyFramesRawData(rawFrameData);
    (ingenuity.parserModel as GameParserModel).setStickyFramesPosition([]);
  }



  /**
   * add sticky wild to container
   */
  private addStickyWildSymbol(evt: IEvent): void {
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      this.stickySymbolContainer.visible = true;
      this.stickyFramesContainer.visible = true;
      this.stickyFramesContainer.alpha = 1;
    } else {
      this.stickySymbolContainerFG.visible = true;
      this.stickyFramesContainerFG.visible = true;
      this.stickyFramesContainerFG.alpha = 1;
    }
    this.stickyData = [];
    this.stickyData = evt.data;
    if (this.stickyData) {
      this.addStickyFrames(this.stickyData);
    }
  }


  private glowAllFrames(): void {
    setTimeout(() => {
      this.stickyFramesContainer.children.forEach((element: SpineBase) => {
        element.playAnim('animation');
      });
    }, SlotConstantsBehavior.DURATION_100)
  }

  private setStickyData(offsets: number[]): void {
    let totalSticky = (ingenuity.parserModel as GameParserModel).getStickyFramesPosition();
    const exists = totalSticky.some(subArr =>
      subArr.length === offsets.length &&
      subArr.every((val, index) => val === offsets[index])
    );
    if (exists) return;
    totalSticky.push(offsets);
    (ingenuity.parserModel as GameParserModel).setStickyFramesPosition(totalSticky);
  }

  /**
   * add stciky wild one by one
   * @param index 
   */
  private addStickyFrames(stickyFramesData: number[][]): void {
    //   (ingenuity.soundManager as any).playSound(SoundConstantGame.BRONZE_APPEAR_SOUND, 1, false, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);
    stickyFramesData.forEach((element: any) => {
      this.setStickyData(element);
      let childExist = null;
      if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
        childExist = this.stickyFramesContainer.getChildByName(`frame_${element[0]}_${element[1]}`);
      } else {
        childExist = this.stickyFramesContainerFG.getChildByName(`frame_${element[0]}_${element[1]}`);
      }
      if (!childExist) {
        let wildSpine = clone(ingenuity.assetsData.getJSONById("main_data").stickyFrameSymbol['symbol_frame_animation']);
        wildSpine.type = "spine";
        let child = this.view.createSpineClone(wildSpine);
        child.visible = true;
        child.name = `frame_${element[0]}_${element[1]}`;
        child.json.id = `frame_${element[0]}_${element[1]}`;
        child.x = this.view.json.symWidth * element[0] + (element[0] * 2);
        child.y = this.view.json.symHeight * element[1] + ((element[1] - 4) * 2);
        if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
          this.stickyFramesContainer.addChild(child);
        } else {
          this.stickyFramesContainerFG.addChild(child)
        }
        //(ingenuity.soundManager as any).playSound(SoundConstantGame.STICKY_SYMBOL_SOUND, 1, false, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);
        child.playAnim('animation');
      }
    });
  }


}